module.exports = __webpack_public_path__ + "img/creative.89e1089b.png";